import EnvirotainerState from "./Envirotainer/EnvirotainerState";
import { PT300State } from "./PT300/PT300State";
import { TNumberProperty } from "../types/TNumberProperty";
import { TBooleanProperty } from "../types/TBooleanProperty";
import { TLocationProperty } from "../types/TLocationProperty";
import { IAnyObject } from "../interfaces";

export const parseHistory = (data: IAnyObject, sensor: string, deviceType: string, battId?: string): TNumberProperty|TBooleanProperty|TLocationProperty => {
	switch (deviceType.toUpperCase()) {
		case "ENVIROTAINER": {
			return EnvirotainerState.parseHistory(data, sensor);
		}
		case "PT300D":
		case "PT300": {
			return PT300State.parseHistory(data, sensor, battId);
		}
		default:
			return EnvirotainerState.parseHistory(data, sensor);
	}
};

export const parseSensor = (sensor: string, deviceType: string, forward: boolean): string => {
	switch (deviceType.toUpperCase()) {
		case "ENVIROTAINER": {
			return sensor;
		}
		case "PT300D":
		case "PT300": {
			return PT300State.parseSensor(sensor, forward);
		}
		default:
			return sensor;
	}
};

